import { render } from "./Customers.vue?vue&type=template&id=43bce59a"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=43bce59a&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__